const modelProviderMapping: { [key: string]: string } = {
    "Claude-Fable": "Anthropic",
    "Claude-Opus": "Anthropic",
    "Claude-Sonnet": "Anthropic",
    "Claude-Haiku": "Anthropic",
    "GPT": "OpenAI",
    "GPT-Mini": "OpenAI",
    "Gemini-Pro": "Google",
    "Gemini-Flash": "Google",
    "Grok": "xAI",
    "GLM": "Other"
};

export default modelProviderMapping;
